export default __webpack_public_path__ + "static/media/flaot_FIN.43bafaab.gif";